import type { components } from "../../../api/generated";
import type { RailwaySeat, RailwayStationsData, RailwayStopsData, RailwayTicketsData } from "../types";

export type RailwayStationsRaw = components["schemas"]["RailwayStationsData"];
export type RailwayTicketsRaw = components["schemas"]["RailwayTicketsData"];
export type RailwayStopsRaw = components["schemas"]["RailwayStopsData"];
type RailwaySeatRaw = components["schemas"]["RailwaySeat"];

/** 将生成契约映射到独立领域类型，编译时校验日期窗口与车站字段。 */
export function mapRailwayStations(raw: RailwayStationsRaw): RailwayStationsData { return raw; }

/** 可选价格与铺位统一为明确空值，余票状态始终保留。 */
export function mapRailwaySeat(raw: RailwaySeatRaw): RailwaySeat {
  return { ...raw, count: raw.count ?? null, price: raw.price ?? null, discount: raw.discount ?? null,
    waitlist: raw.waitlist ?? "unknown", berths: (raw.berths ?? []).map((berth) => ({ ...berth, discount: berth.discount ?? null })) };
}

/** 在唯一契约边界收敛车次和席别结构。 */
export function mapRailwayTickets(raw: RailwayTicketsRaw): RailwayTicketsData {
  return { ...raw, trains: raw.trains.map((train) => ({ ...train, seats: train.seats.map(mapRailwaySeat) })) };
}

/** 停站结构通过显式返回类型校验，不推算未返回的时间。 */
export function mapRailwayStops(raw: RailwayStopsRaw): RailwayStopsData { return raw; }
